import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SapCodeQuotaAvailabilityDto } from '../../api-client';

// The availability lives in the store and not in the components because BVCompactForm is inside every product
// card: keeping it here guarantees one call per customer instead of one per card.
interface QuotaState {
	/** Availability indexed by sap code. A missing code means no quota, hence unlimited. */
	availabilityBySapCode: Record<string, SapCodeQuotaAvailabilityDto>;
	/** Customer the cached availability is valid for. */
	loadedForCustomerId?: number;
	loading: boolean;
}

const initialState: QuotaState = {
	availabilityBySapCode: {},
	loadedForCustomerId: undefined,
	loading: false,
};

export const quotaSlice = createSlice({
	name: 'quota',
	initialState,
	reducers: {
		setQuotaAvailabilityLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},

		initQuotaAvailability: (
			state,
			action: PayloadAction<{
				customerId: number;
				availability: SapCodeQuotaAvailabilityDto[];
			}>,
		) => {
			const map: Record<string, SapCodeQuotaAvailabilityDto> = {};

			action.payload.availability.forEach((entry) => {
				if (entry.sapCode) map[entry.sapCode] = entry;
			});

			state.availabilityBySapCode = map;
			state.loadedForCustomerId = action.payload.customerId;
			state.loading = false;
		},

		clearQuotaAvailability: (state) => {
			state.availabilityBySapCode = {};
			state.loadedForCustomerId = undefined;
			state.loading = false;
		},
	},
});

export const {
	setQuotaAvailabilityLoading,
	initQuotaAvailability,
	clearQuotaAvailability,
} = quotaSlice.actions;

export default quotaSlice.reducer;
